import React, { PureComponent, Fragment } from 'react';
import { Link } from 'formlabs-web-components/Link';

import './HeaderMenu.module.css';

export default class TertiaryMenu extends PureComponent {
  render() {
    const { items } = this.props;
    return (
      <Fragment>
        {items.map((item, i) => {
          return item.visible ? (
            <Link
              to={item.url}
              styleName={`dropdown-left tertiary-menu`}
              key={`${item.url}-${i}`}
            >
              <span>{item.name} </span>
            </Link>
          ) : null;
        })}
      </Fragment>
    );
  }
}
